// HotX Unified Edge V1.7 - latest production source authentication fix.
// Updated: 2026-09-09 03:20:34 CST.
// Parent production baseline: 620811fa36cce55b2f4e2a7afddc18a432831704.

import type { OperationView, ServiceView } from './model'
import { httpClient } from '../../api/client'

export class UnifiedEdgeApiError extends Error {
  constructor(public readonly code: string, message: string, public readonly status: number) {
    super(message)
  }
}

interface UnifiedRequestOptions {
  method?: 'GET' | 'POST' | 'DELETE'
  headers?: Record<string, string>
  body?: unknown
}

async function request<T>(path: string, options: UnifiedRequestOptions = {}): Promise<T> {
  try {
    const config = options.headers ? { headers: options.headers } : undefined
    if (options.method === 'POST') return await httpClient.post<T>(path, options.body, config)
    if (options.method === 'DELETE') return await httpClient.delete<T>(path, config)
    return await httpClient.get<T>(path, config)
  } catch (error) {
    const apiError = error as Error & { code?: string; status?: number }
    throw new UnifiedEdgeApiError(
      apiError.code || 'UNDETERMINED_FAILURE',
      apiError.message || '无法判断具体原因，请联系管理员',
      apiError.status || 0,
    )
  }
}

export function createService(payload: unknown, idempotencyKey: string): Promise<ServiceView> {
  return request('/api/v1/unified-edge/services', {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: payload,
  })
}

export function listServices(): Promise<ServiceView[]> {
  return request('/api/v1/unified-edge/services')
}

export function publishService(serviceId: number, expectedVersion: number, idempotencyKey: string): Promise<OperationView> {
  return request(`/api/v1/unified-edge/services/${serviceId}/publish`, {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: { expectedVersion },
  })
}

export function migrateService(serviceId: number, expectedVersion: number, idempotencyKey: string): Promise<OperationView> {
  return request(`/api/v1/unified-edge/services/${serviceId}/migrate`, {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: { expectedVersion },
  })
}

export function deleteService(serviceId: number, idempotencyKey: string): Promise<OperationView> {
  return request(`/api/v1/unified-edge/services/${serviceId}`, {
    method: 'DELETE',
    headers: { 'Idempotency-Key': idempotencyKey },
  })
}

export function getOperation(operationId: string): Promise<OperationView> {
  return request(`/api/v1/unified-edge/operations/${encodeURIComponent(operationId)}`)
}
